import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

/* Common elements */
import Header from './view/Header';
import TopToolbar from './view/TopToolbar';
import Footer from './view/Footer';

/* Pages */
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Help from './pages/Help';
import TermsOfUse from './pages/TermsOfUse';
import Contact from './pages/Contact';
import ContactTy from './pages/ContactTy';
import Search from './pages/Search';
import NotFound from './pages/NotFound';

/* Blog */
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';

/* Contracts */
import Contracts from './pages/contracts/Contracts';

// Real Estate
import ContractsRealEstate from './pages/contracts/real-estate/RealEstate';
import ContractsRealEstateContractToSell from './pages/contracts/real-estate/contract-to-sell/ContractToSell';
import ContractsRealEstateDeedOfAbsoluteSale from './pages/contracts/real-estate/deed-of-absolute-sale/DeedOfAbsoluteSale';
import ContractsRealEstateRealEstateMortgage from './pages/contracts/real-estate/real-estate-mortgage/RealEstateMortgage';

// Free Contracts
import ContractsFreeContracts from './pages/contracts/free-contracts/FreeContracts';
import ContractsFreeContractsBoardResolutionToSell from './pages/contracts/free-contracts/board-resolution-to-sell/BoardResolutionToSell';
import ContractsFreeContractsEanestMoneyAgreement from './pages/contracts/free-contracts/earnest-money-agreement/EarnestMoneyAgreement';
import ContractsFreeContractsOptionContract from './pages/contracts/free-contracts/option-contract/OptionContract';
import ContractsFreeContractsSecretaryCertificateToSell from './pages/contracts/free-contracts/secretary-certificate-to-sell/SecretaryCertificateToSell';
import ContractsFreeContractsSpecialPowerOfAttorneyToSell from './pages/contracts/free-contracts/special-power-of-attorney-to-sell/SpecialPowerOfAttorneyToSell';

// Business
import ContractsBusiness from './pages/contracts/business/Business';
import ContractsBusinessPromissoryNote from './pages/contracts/business/promissory-note/PromissoryNote';
import ContractsBusinessDeedOfSaleOfMotorVehicle from './pages/contracts/business/deed-of-sale-of-motor-vehicle/DeedOfSaleOfMotorVehicle';

class App extends Component {

    render() {
        return (
            <div className="App">
                <TopToolbar />
                <Header />

                {/* Updateble elelments */}
                <Switch>
                    <Route exact 
                        path="/" 
                        component={Home} />
                    <Route
                        path="/about-us"
                        component={AboutUs} />
                    <Route 
                        path="/help" 
                        component={Help} />
                    <Route exact
                        path="/contact"
                        component={Contact} />
                    <Route
                        path="/contact/ty"
                        component={ContactTy} />
                    <Route
                        path="/terms-of-use"
                        component={TermsOfUse} />
                    <Route exact
                        path="/contracts"
                        component={Contracts} />
                    <Route exact
                        path="/search"
                        component={Search} />
                    <Route
                        path="/search/:search"
                        component={Search} />

                    
                    {/* Real estate */}
                    <Route exact 
                        path="/contracts/real-estate" 
                        component={ContractsRealEstate} />
                    <Route 
                        path="/contracts/real-estate/contract-to-sell" 
                        component={ContractsRealEstateContractToSell} />
                    <Route 
                        path="/contracts/real-estate/deed-of-absolute-sale" 
                        component={ContractsRealEstateDeedOfAbsoluteSale} />
                    <Route 
                        path="/contracts/real-estate/real-estate-mortgage" 
                        component={ContractsRealEstateRealEstateMortgage} />

                    {/* Free contracts */}
                    <Route exact 
                        path="/contracts/free-contracts" 
                        component={ContractsFreeContracts} /> 
                    <Route
                        path="/contracts/free-contracts/board-resolution-to-sell" 
                        component={ContractsFreeContractsBoardResolutionToSell} />
                    <Route 
                        path="/contracts/free-contracts/earnest-money-agreement" 
                        component={ContractsFreeContractsEanestMoneyAgreement} />
                    <Route
                        path="/contracts/free-contracts/option-contract"
                        component={ContractsFreeContractsOptionContract} />
                    <Route 
                        path="/contracts/free-contracts/secretary-certificate-to-sell" 
                        component={ContractsFreeContractsSecretaryCertificateToSell} />
                    <Route
                        path="/contracts/free-contracts/special-power-of-attorney-to-sell"
                        component={ContractsFreeContractsSpecialPowerOfAttorneyToSell} />

                    {/* Business */}
                    <Route exact
                        path="/contracts/business"
                        component={ContractsBusiness} />
                    <Route
                        path="/contracts/business/promissory-note"
                        component={ContractsBusinessPromissoryNote} />
                    <Route
                        path="/contracts/business/deed-of-sale-of-motor-vehicle"
                        component={ContractsBusinessDeedOfSaleOfMotorVehicle} />

                    {/* Articles */}
                    <Route exact
                        path="/blog"
                        component={Blog} />
                    <Route
                        path="/blog/:title"
                        component={BlogPost} />

                    {/* Others */}
                    <Route 
                        component={NotFound} />        
                </Switch>

                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js